import React, { useEffect, useState, useRef } from 'react';
import { fetchStats } from './realTalkApi';

export default function HeroSection() {
  const [stats, setStats] = useState({ total_reviews: 0, colleges_covered: 0 });
  const [displayCount, setDisplayCount] = useState(0);
  const countRef = useRef(null);

  useEffect(() => {
    fetchStats().then((data) => setStats(data)).catch(() => {});
  }, []);

  useEffect(() => {
    const target = stats.total_reviews;
    if (target === 0) return;
    let current = 0;
    const step = Math.max(1, Math.floor(target / 60));
    const interval = setInterval(() => {
      current += step;
      if (current >= target) { current = target; clearInterval(interval); }
      setDisplayCount(current);
    }, 30);
    return () => clearInterval(interval);
  }, [stats.total_reviews]);

  const scrollToForm = () => {
    const form = document.getElementById('rt-submission-form');
    if (form) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="rt-hero" data-testid="rt-hero">
      <div className="rt-hero-inner">
        <div className="rt-hero-badge">CAMPUS TRUTH · Verified student experiences</div>
        <h1 className="rt-hero-title">
          Real students. Real colleges. <span className="rt-gold">Real experience.</span>
        </h1>
        <p className="rt-hero-hindi">कॉलेज का असली सच जानें</p>
        <p className="rt-hero-subtitle">Honest written and voice reviews from students who actually go there. No brochure talk. No sugar-coating.</p>
        <button onClick={scrollToForm} className="rt-hero-cta" data-testid="rt-hero-cta">Share Your College Experience →</button>
        <div className="rt-hero-stats">
          {stats.total_reviews > 0 && (
            <>
              <div className="rt-stat">
                <span className="rt-stat-num" ref={countRef}>{displayCount.toLocaleString('en-IN')}</span>
                <span className="rt-stat-label">Verified Verdicts</span>
              </div>
              <div className="rt-stat-divider" />
              <div className="rt-stat">
                <span className="rt-stat-num">{stats.colleges_covered.toLocaleString('en-IN')}</span>
                <span className="rt-stat-label">Colleges Covered</span>
              </div>
            </>
          )}
          {stats.total_reviews === 0 && (
            <p className="rt-hero-launch">Be the first to share your honest college experience.</p>
          )}
        </div>
      </div>
      <div className="rt-hero-bg-pattern" aria-hidden="true" />
    </section>
  );
}
